import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  viewMode, 
  onViewModeChange, 
  onNavigate, 
  onTodayClick 
}) => {
  const formatHeaderDate = () => {
    const options = { 
      year: 'numeric', 
      month: 'long',
      ...(viewMode === 'day' && { day: 'numeric' })
    };
    return currentDate?.toLocaleDateString('de-DE', options);
  };

  return (
    <div className="flex items-center justify-between p-4 bg-card border-b border-border">
      <div className="flex items-center space-x-4">
        <h2 className="text-xl font-semibold text-foreground">
          {formatHeaderDate()}
        </h2>
        <Button
          variant="outline"
          size="sm"
          onClick={onTodayClick}
        >
          Heute
        </Button>
      </div>
      <div className="flex items-center space-x-2">
        {/* Navigation Controls */}
        <div className="flex items-center space-x-1">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onNavigate('prev')}
          >
            <Icon name="ChevronLeft" size={20} />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onNavigate('next')}
          >
            <Icon name="ChevronRight" size={20} />
          </Button>
        </div>

        {/* View Mode Selector */}
        <div className="flex items-center bg-muted rounded-lg p-1">
          {['month', 'week', 'day']?.map((mode) => (
            <Button
              key={mode}
              variant={viewMode === mode ? "default" : "ghost"}
              size="sm"
              onClick={() => onViewModeChange(mode)}
              className="px-3 py-1 text-xs"
            >
              {mode === 'month' ? 'Monat' : mode === 'week' ? 'Woche' : 'Tag'}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;